// Diccionario español — idioma por defecto de la herramienta.
// Las claves espejo en en.js; si falta una, el hook cae de vuelta aquí.
const es = {
  lang: { switch: 'Idioma' },

  common: {
    delete: 'Eliminar',
    edit: 'Editar',
    retry: 'Reintentar',
    dash: '—',
    save: 'Guardar',
    back: '← Regresar',
    close: 'Cerrar',
    never: 'Nunca',
    unassigned: 'Sin asignar',
    daysShort: '{count} d',
    ofTotal: '{active} de {total}',
  },

  nav: {
    quotes: 'Cotizaciones',
    dashboard: 'Tablero',
    accounts: 'Cuentas',
    calendar: 'Calendario',
  },

  bands: {
    healthy: 'Saludable',
    watch: 'En observación',
    at_risk: 'En riesgo',
  },

  renewalStatus: {
    confirmed: 'Confirmada',
    in_progress: 'En proceso',
    not_started: 'Sin iniciar',
    churned: 'Perdida',
  },

  billingFrequency: {
    monthly: 'Mensual',
    annual: 'Anual',
  },

  roles: {
    admin: 'Administrador',
    sales: 'Ventas',
    cs_agent: 'Agente CS',
    none: 'Sin perfil',
  },

  roleSummary: {
    admin: 'Todo, incluida esta consola',
    sales: 'Renovación, ARR y dueño de ventas',
    cs_agent: 'Nombre, cuenta interna, dueño CS y sesiones',
  },

  sources: {
    mpindustries: 'MPIndustries',
    mpservices: 'MPServices',
  },

  // Banderas que arma el backend; se traducen aquí por código.
  flags: {
    never_activated: 'Nunca activada · 0 de {total_users} licencias han iniciado sesión',
    seat_decay: 'Activación de licencias cayó {drop}% vs. los 30 días previos',
    admin_only: 'Uso sólo de administradores por 30 días',
    renewal_near: 'Renovación en {days} días',
    unowned: 'Sin dueño de CS asignado',
  },

  layout: {
    brandPrefix: 'MP',
    brandName: 'INTERNAL',
    accountMenu: 'Cuenta y administración',
    usersAndPermissions: 'Usuarios y permisos',
    logout: 'Cerrar sesión',
  },


  dashboard: {
    ownerFilter: {
      label: 'Usuario',
      all: 'Todo el equipo',
    },
    tasks: {
      empty: 'No hay tareas abiertas.',
      overdue: '{count} vencida(s)',
    },
    loadError: 'No se pudo cargar el tablero. Inténtalo de nuevo.',
    stats: {
      contactToday: 'Contactar hoy',
      atRisk: 'En riesgo',
      atRiskHint: 'de {total} gestionadas',
      renewals90d: 'Renovaciones · 90 días',
      renewalsHint: '{count} confirmadas',
      renewalRate: 'Tasa de renovación · 3 meses',
      renewalRateOf: '{renewed} de {due}',
      renewalRateNone: 'sin vencimientos',
      unassigned: 'Sin asignar',
      awaitingAttendance: 'Asistencia pendiente',
      contacted30d: 'Contactados · 30 días',
      contactedHint: '{responded} respondieron · {sessions} sesiones',
    },
    contactToday: {
      title: 'Contactar hoy',
      action: 'Enterprise primero, luego Business',
      empty: 'Nadie necesita una llamada hoy — todas las cuentas en riesgo se contactaron en los últimos 7 días.',
      neverContacted: 'Nunca contactada',
      lastContact: 'Último contacto hace {days} días',
      scoreTrending: 'Score {score} · a la baja',
      open: 'Abrir',
      assign: 'Asignar',
    },
    renewals: {
      title: 'Próximas renovaciones',
      action: 'Este mes y los próximos 3',
      empty: 'No hay fechas de renovación este mes ni en los próximos tres. Captúralas en una cuenta para verlas aquí.',
      daysAgo: 'hace {count} d',
      score: 'score {score}',
    },
    renewalMonth: {
      title: 'Renovaciones de {month}',
      summary: '{renewed} de {due} renovadas',
      empty: 'No había renovaciones programadas este mes.',
      due: 'Programada {date}',
      renewedOn: 'Renovada el {date}',
      renewed: 'Renovada',
    },
    contacted: {
      title: 'Contactados en el último mes',
      action: 'Últimos 30 días',
      empty: 'Nadie registró un contacto en los últimos 30 días. Se captura en los contactos de cada cuenta.',
      responded: 'Respondió',
      noResponse: 'Sin respuesta',
      waiting: 'Pendiente',
      session: 'Agendó sesión',
    },
    closeMonth: {
      button: 'Cerrar mes de renovaciones',
      title: 'Cerrar mes de renovaciones',
      intro: 'Las renovaciones confirmadas de meses ya terminados pasan al historial, su siguiente fecha se corre un periodo y vuelven a «Sin iniciar». Las que vencieron sin confirmarse no se tocan: aparecerán aquí para revisarlas. Las de este mes no se cierran todavía.',
      confirm: 'Cerrar mes',
      running: 'Cerrando…',
      error: 'No se pudo cerrar el mes.',
      summary: 'Vencimientos antes del {date}: {closed} renovadas cerradas, {notRenewed} sin renovar.',
      nothing: 'No había renovaciones pendientes de cerrar.',
      notRenewed: 'Sin renovar',
      missingFrequency: 'Confirmadas sin frecuencia',
      missingFrequencyHint: 'captura la frecuencia y vuelve a cerrar',
      closed: 'Cerradas',
      next: 'siguiente {date}',
    },
  },

  accounts: {
    saveError: 'No se pudo guardar el cambio.',
    loadError: 'No se pudieron cargar las cuentas. Inténtalo de nuevo.',
    search: 'Buscar organización…',
    allSources: 'Todos los productos',
    inactiveBadge: 'POR DESACTIVAR',
    studentBadge: 'ESTUDIANTE',
    internalBadge: 'INTERNA',
    noName: 'sin nombre',
    createdOn: 'Creada {date} · {source}',
    views: {
      mine: 'Mis cuentas',
      enterprise: 'Enterprise',
      businessPlus: 'Business Plus',
      renewing: 'Renuevan este trimestre',
      unowned: 'En riesgo y sin dueño',
      inactive: 'Nunca activadas',
      all: 'Todas',
      internal: 'Internas',
      toDeactivate: 'Por desactivar',
      free: 'Free',
      students: 'Estudiantes',
    },
    columns: {
      organization: 'Organización',
      subscription: 'Suscripción',
      seatsActive: 'Licencias activas',
      csOwner: 'Dueño CS',
      salesOwner: 'Dueño ventas',
      renewal: 'Renovación',
      billingFrequency: 'Frecuencia',
      lastRenewal: 'Última renovación',
      score: 'Score',
      health: 'Salud',
      users: 'Usuarios',
      lastLogin: 'Último acceso',
      status: 'Estatus',
    },
  },

  products: {
    title: 'Productos y precios',
    intro: 'El catálogo que se ofrece al cotizar. Editar un precio no cambia las cotizaciones ya hechas: cada una guarda una copia de lo que se ofreció.',
    new: 'Nuevo producto',
    name: 'Nombre',
    description: 'Descripción',
    unit: 'Unidad',
    active: 'Activo',
    inactive: 'Inactivo',
    historyNote: 'Los cambios de precio quedan registrados con autor y fecha.',
    loadError: 'No se pudo cargar el catálogo.',
    saveError: 'No se pudo guardar el producto.',
    forbidden: 'Sólo un administrador puede editar el catálogo.',
  },
  timeline: {
    deleteConfirm: '¿Borrar esta nota? No se puede deshacer.',
    deleteError: 'No se pudo borrar la nota.',
    title: 'Historial',
    addNote: 'Agregar nota',
    notePlaceholder: '¿Qué pasó con esta cuenta?',
    empty: 'Todavía no hay actividad registrada.',
    edited: 'editada',
    loadError: 'No se pudo cargar el historial.',
    saveError: 'No se pudo guardar la nota.',
  },
  contacts: {
    title: 'Contactos',
    add: 'Nuevo contacto',
    empty: 'Sin contactos capturados.',
    name: 'Nombre',
    jobTitle: 'Puesto',
    email: 'Correo',
    whatsapp: 'WhatsApp',
    whatsappHint: 'WhatsApp con lada (52 55 1234 5678)',
    whatsappOpen: 'Abrir conversación de WhatsApp',
    noCountryCode: 'El número no trae lada de país, así que no se puede abrir WhatsApp. Complétalo para tener la liga.',
    primary: 'Principal',
    makePrimary: 'Marcar como contacto principal',
    unsetPrimary: 'Quitar como contacto principal',
    loadError: 'No se pudieron cargar los contactos.',
    saveError: 'No se pudo guardar el contacto.',
    deleteError: 'No se pudo borrar el contacto.',
    deleteConfirm: '¿Borrar este contacto? No se puede deshacer.',
    lastContact: 'Último contacto',
    today: 'hoy',
    responded: 'Respondió',
    respondedUnknown: '—',
    respondedYes: 'Sí',
    respondedNo: 'No',
    sessionScheduled: 'Agendó sesión',
  },
  implementation: {
    title: 'Plan de implementación',
    empty: 'Esta cuenta Enterprise aún no tiene plan de implementación.',
    add: 'Agregar plan',
    open: 'Abrir plan',
    summary: '{done} de {total} tareas · actualizado {date}',
    progress: 'Avance',
    exportPdf: 'Exportar PDF',
    exporting: 'Generando PDF…',
    saving: 'Guardando…',
    saved: 'Guardado',
    saveError: 'No se pudo guardar',
    lastUpdate: 'Última edición: {date} · {name}',
    readOnly: 'Tu perfil puede consultar el plan pero no editarlo.',
    onlyEnterprise: 'El plan de implementación es sólo para cuentas Enterprise.',
    noPlan: 'Esta cuenta aún no tiene plan de implementación. Créalo desde el detalle de la cuenta.',
    loadError: 'No se pudo cargar el plan de implementación.',
    createError: 'No se pudo crear el plan de implementación.',
    exportError: 'No se pudo generar el PDF.',
    alwaysPhase1: 'Siempre en fase 1',
    steps: {
      account: 'Cuenta y responsable',
      start: 'Punto de partida',
      startHint: '¿Cómo gestionan hoy su mantenimiento?',
      plants: 'Plantas y piloto',
      plantsHint: 'Empezamos con una organización (planta o base de datos) y de ahí escalamos.',
      scope: 'Qué implementar primero',
      scopeHint: '¿Qué tendría que estar funcionando para decir que la implementación fue un éxito?',
      users: 'Usuarios y roles',
      notes: 'Integraciones y notas',
      tracking: 'Seguimiento del plan',
      trackingHint: 'Las tareas se ajustan a lo que marcaste arriba. Toca el estado para moverlo: Pendiente, En curso, Hecho.',
    },
    fields: {
      client: 'Cliente',
      kickoff: 'Fecha del kickoff',
      csm: 'Customer Success',
      owner: 'Responsable de implementación del cliente',
      ownerHint: 'Sin esta persona el proyecto no avanza. Confírmalo en el kickoff.',
      name: 'Nombre',
      jobTitle: 'Puesto',
      email: 'Correo',
      admin: 'Administrador de la cuenta (quien registra primero)',
      adminHint: 'Si es la misma persona, repite el nombre',
      plants: 'Número de plantas',
      locations: 'Ubicaciones',
      pilot: 'Organización piloto',
      pilotHint: 'Planta o base de datos con la que empezamos',
      integrations: 'Integraciones',
      integrationsHint: 'Sistema, cuál usan, fase 1 o después, contacto de TI',
      notes: 'Notas y riesgos',
      notesHint: 'Lo que pueda frenar el proyecto',
    },
  },
  tasks: {
    deleteConfirm: '¿Borrar esta tarea? No se puede deshacer.',
    deleteError: 'No se pudo borrar la tarea.',
    title: 'Tareas',
    add: 'Nueva tarea',
    placeholder: '¿Qué hay que hacer?',
    due: 'Vence',
    noDate: 'Sin fecha',
    assignToMe: 'Asignarme a mí',
    empty: 'Sin tareas pendientes.',
    loadError: 'No se pudieron cargar las tareas.',
    saveError: 'No se pudo guardar la tarea.',
  },
  quote: {
    issuer: 'Emite',
    client: 'Cliente',
    conditions: 'Condiciones',
    pageOf: 'Página {page} de {total}',
    validUntilHelp: 'Un mes por omisión',
    validUntil: 'Válida hasta',
    pdfError: 'No se pudo generar el PDF.',
    isRenewal: 'Renovación',
    newClient: 'Cliente nuevo',
    renewalHelp: 'Marca si esta cotización renueva a un cliente existente',
    type: 'Tipo',
    accountQuotes: 'Cotizaciones',
    quote: 'Cotización',
    quotes: 'Cotizaciones',
    createdDate: 'Fecha de creación',
    doneBy: 'Elaborada por',
    note: 'Nota',
    folio: 'Folio',
    company: 'Empresa',
    contact: 'Contacto',
    currency: 'Moneda',
    country: 'País',
    office: 'Oficina emisora',
    payment: 'Forma de pago',
    products: 'Productos',
    account: 'Cuenta ligada',
    linkAccount: 'Ligar a una cuenta',
    notLinked: 'Sin ligar',
    send: 'Enviar por correo',
    downloadPdf: 'Descargar PDF',
    newQuote: 'Nueva cotización',
    sendTo: 'Enviar a',
    sent: 'Cotización enviada',
    mailNotConfigured: 'El envío de correo no está configurado en el servidor.',
    loadError: 'No se pudieron cargar las cotizaciones.',
    saveError: 'No se pudo guardar la cotización.',
    deleteConfirm: '¿Eliminar esta cotización?',
    total: 'Total',
    status: {
      draft: 'Borrador', sent: 'Enviada', accepted: 'Aceptada',
      rejected: 'Rechazada', expired: 'Vencida',
    },
    views: { all: 'Todas', mine: 'Mías', renewals: 'Renovaciones', newClients: 'Clientes nuevos' },
  },
  general: {
    pay_terms: 'Forma de pago',
    quantity: 'Cant.',
    unitPrice: 'P. unitario',
    amount: 'Importe',
    product_des: 'Concepto',
    price_notaxes: 'Precios no incluyen impuestos',
    discount: 'Descuento',
    taxes: 'Impuestos',
    price: 'Precio',
    from: 'De',
    to: 'Para',
    subtotal: 'Subtotal',
  },
  accountDetail: {
    timeline: 'Historial',
    inactiveAccount: 'Cuenta por desactivar',
    inactiveManual: 'Definido manualmente',
    inactiveNone: 'Sin señales de baja',
    inactiveReason: {
      subscription_off: 'Suscripción apagada en producto',
      no_active_users: 'Sin ningún usuario activo',
      dormant: 'Sin accesos en más de 180 días',
    },
    studentAccount: 'Cuenta de estudiante',
    studentDetected: 'Detectado por dominio ({edu} de {total} usuarios .edu)',
    studentManual: 'Definido manualmente',
    studentHint: 'Se excluye de la vista general y del dashboard',
    licensedSeats: 'Licencias',
    freeUsers: 'Usuarios libres',
    freeUsersHint: '{active} de {total} activos · no consumen licencia',
    contracted: '{contracted} contratadas',
    csOwner: 'Responsable CS',
    salesOwner: 'Responsable de ventas',
    ownerNoAccess: 'sin acceso a la herramienta',
    assignOwners: 'Asignación',
    loadError: 'No se pudo cargar esta cuenta.',
    saveError: 'No se pudo guardar tu cambio. Inténtalo de nuevo.',
    created: 'Creada',
    seatsActive: 'Licencias activas',
    renewal: 'Renovación',
    renewalStatus: 'Estatus de renovación',
    currentStatus: 'Estatus actual',
    billingFrequency: 'Frecuencia de suscripción',
    lastRenewal: 'Última renovación',
    sessions: 'Sesiones',
    lastSession: '· última {date}',
    sessionsPending: '· {count} sin respuesta',
    training: 'Capacitación',
    trainingDone: '{count} impartidas',
    trainingTarget: 'contratadas',
    orgName: 'Nombre de la organización',
    orgNamePlaceholder: 'Capturar nombre',
    inProduct: 'En producto: {name}',
    noProductName: 'Producto no tiene nombre para este tenant.',
    savedInternally: 'Se guarda sólo en la BD interna.',
    internalAccount: 'Cuenta interna de MP',
    internalDetected: 'Detectado por dominio ({internal} de {total} usuarios)',
    internalManual: 'Definido manualmente',
    whyScore: 'Por qué este score',
    weight: '{percent}% de peso',
    usersCount: 'Usuarios · {count}',
      tips: {
        activation: 'Usuarios con licencia que entraron en los últimos 30 días, sobre el total de usuarios con licencia. Los roles libres (técnico, vendedor, líder técnico, sólo lectura) no cuentan aquí porque no consumen contrato.',
        recency: 'Días desde el último acceso de un usuario con licencia. 100 el mismo día, 0 a los 45 días sin entrar.',
        trend: 'Usuarios con licencia activos en los últimos 30 días contra los 30 anteriores. Mantenerse igual da 70; crecer sube hasta 100.',
        breadth: 'Roles distintos que se conectaron en 30 días, sobre los roles que existen en la cuenta. Cuenta a todos los que entran, con licencia o libres: el uso concentrado en un solo perfil anticipa abandono.',
      },
    parts: {
      activation: 'Activación de licencias',
      recency: 'Último login',
      trend: 'Tendencia',
      breadth: 'Amplitud de uso',
    },
  },

  calendar: {
    loadError: 'No se pudo cargar tu calendario.',
    calendarsError: 'No se pudieron cargar los calendarios del equipo.',
    notConfigured: 'La conexión con Google Calendar no está configurada en el servidor. Faltan: {missing}',
    footnote: 'Eventos de Google Calendar · vincula una reunión para que cuente en la bitácora de la cuenta',
    ownerLabel: 'Calendario',
    allCalendars: 'Todos · {count} personas',
    noConsoleAccess: 'sin acceso a la consola',
    someFailed: 'No se pudo leer el calendario de: {owners}. El resto de la semana sí se muestra.',
    untitled: 'Reunión sin título',
    noAccount: 'Sin cuenta asociada',
    noEvents: 'Sin eventos esta semana.',
    allDay: 'Todo el día',
    when: 'Cuándo',
    location: 'Lugar',
    organizer: 'Organiza',
    attendees: 'Asistentes',
    account: 'Cuenta',
    pickAccount: 'Buscar cuenta…',
    link: 'Vincular',
    linkError: 'No se pudo vincular la reunión.',
    linkNoPermission: 'Tu perfil no puede vincular reuniones.',
    openAccount: 'Abrir cuenta',
    openInGoogle: 'Ver en Google Calendar ↗',
    confirmAttendance: 'Confirmar asistencia',
    attendanceQuestion: '¿Cómo salió la reunión?',
    attendanceError: 'No se pudo registrar la asistencia.',
    session: 'Sesión',
    sessionHint: 'El tipo y la nota se guardan al vincular la reunión con una cuenta.',
    saveSession: 'Guardar',
    sessionSaved: 'Guardado',
    sessionSaveError: 'No se pudo guardar la sesión.',
    reason: {
      domain: 'Sugerida por el dominio de los invitados; confírmala para vincularla.',
      ambiguous: 'Varias cuentas coinciden con los invitados; elige una.',
      no_match: 'Ningún dominio de los invitados coincide con una cuenta.',
      internal_only: 'Sólo hay asistentes internos en esta reunión.',
    },
    prevWeek: 'Semana anterior',
    nextWeek: 'Semana siguiente',
  },

  attendance: {
    attended: 'Asistieron',
    partial: 'Parcial',
    no_show: 'No llegaron',
    rescheduled: 'Reagendada',
  },

  sessionsLog: {
    title: 'Sesiones',
    empty: 'Sin sesiones registradas.',
    loadError: 'No se pudo cargar la bitácora de sesiones.',
    saveError: 'No se pudo guardar la sesión.',
    add: '+ Registrar',
    cancel: 'Cancelar',
    titlePlaceholder: 'Título de la sesión',
    notesPlaceholder: '¿Qué se vio? Comentarios, acuerdos, pendientes…',
    addNotes: '+ Agregar notas',
    date: 'Fecha',
    kind: 'Tipo',
    countsHint: 'Cuenta para el porcentaje de capacitación de la cuenta.',
    noCountHint: 'Queda en la bitácora; no cuenta para el porcentaje de capacitación.',
    ofInvited: '{attended} de {invited} invitados',
    attendees: '{count} asistentes',
    pending: 'Sin respuesta',
    showAll: 'Ver las {count}',
    showLess: 'Ver menos',
  },

  kinds: {
    training: 'Capacitación inicial',
    support: 'Dudas',
    onboarding: 'Arranque',
    qbr: 'Revisión trimestral',
    check_in: 'Seguimiento',
  },

  usersTable: {
    username: 'Usuario',
    email: 'Correo',
    role: 'Perfil',
    lastLogin: 'Último acceso',
  },

  usersConsole: {
    requests: 'Solicitudes de acceso',
    unnamedUser: 'Usuario sin nombre',
    noEmailWithId: 'sin correo en el token · {id}',
    attemptOne: '{count} intento',
    attemptMany: '{count} intentos',
    lastSeen: 'último {when}',
    admitAs: 'Alta como {role}',
    admit: 'Dar de alta',
    dismiss: 'Descartar',
    admitError: 'No se pudo dar de alta al usuario.',
    dismissError: 'No se pudo descartar la solicitud.',
    registeredNoAccess: 'Dados de alta sin acceso',
    allHaveAccess: 'Todos los miembros del equipo tienen acceso.',
    title: 'Usuarios y permisos',
    intro: 'Auth0 autentica; esta lista autoriza. Quien no esté dado de alta aquí no ve nada de la herramienta, sólo un aviso — su intento aparece arriba como solicitud.',
    forbidden: 'Sólo un administrador puede abrir esta consola.',
    loadError: 'No se pudieron cargar los usuarios.',
    saveError: 'No se pudo guardar el cambio.',
    search: 'Buscar por nombre o correo…',
    withAccess: 'Con acceso',
    rolesTitle: 'Qué puede cada perfil',
    activity: 'Actividad reciente',
    noMatches: 'Nadie coincide con la búsqueda.',
    self: '(tú)',
    blocked: 'Bloqueado en Auth0',
    noEmailInToken: 'Entró sin correo en el token',
    lastAccess: 'último acceso {date}',
    loginCount: '{count} inicios',
    notInAuth0: 'no listado en Auth0',
    lastAdminTooltip: 'No puedes quitarte el último acceso de administrador',
    revoke: 'Revocar',
    grant: 'Dar acceso',
    someone: 'Alguien',
    auth0NotConfigured: 'Sólo aparecen quienes ya entraron. Para ver a todos los registrados, configura una aplicación M2M con permiso {read} en {id} y {secret}.',
    actions: {
      granted: 'dio acceso a',
      revoked: 'revocó acceso a',
      role_changed: 'cambió el perfil de',
      invited: 'invitó a',
    },
  },

  noAccess: {
    pendingTitle: 'Tu acceso está pendiente',
    deniedTitle: 'No tienes acceso a esta herramienta',
    pendingBody: 'Tu cuenta está dada de alta pero todavía no tiene permisos. Un administrador debe activarla.',
    deniedBody: 'Tu cuenta no está en el equipo de Customer Success. Pide a un administrador que te dé de alta con este correo.',
  },

  meErrors: {
    session: 'No se pudo validar tu sesión. Vuelve a iniciar sesión.',
    server: 'No se pudo contactar al servidor.',
  },

  // Errores que el backend devuelve con `code`; si no hay código se muestra el
  // mensaje tal cual llega.
  apiErrors: {
    NOT_REGISTERED: 'Tu cuenta no está dada de alta en esta herramienta.',
    ACCESS_PENDING: 'Tu cuenta aún no tiene acceso. Pide a un administrador que te lo otorgue.',
    FORBIDDEN: 'No tienes permiso para esta acción.',
    ACCOUNT_FORBIDDEN: 'Esta cuenta está asignada a otra persona.',
    FORBIDDEN_FIELDS: 'Tu perfil no puede editar: {fields}',
    NO_EDITABLE_FIELD: 'No se recibió ningún campo editable.',
    SAVE_FAILED: 'No se pudieron guardar los cambios.',
    UNKNOWN_ROLE: 'Perfil desconocido.',
    ACCESS_SAVE_FAILED: 'No se pudo guardar el acceso.',
    USERS_LOAD_FAILED: 'No se pudieron cargar los usuarios.',
  },
};

export default es;
